import { Link } from 'react-router-dom';
import { PATHS } from '@/constants/page-paths';
import { cn } from '@/lib/utils/cn';
import { useSettingsStore } from '@/store';
import { usePermission } from '@/lib/hooks/useRoutePermission';

export const Logo = ({ className }: { className?: string }) => {
  const { themeMode, settings } = useSettingsStore();
  const checkPermission = usePermission();
  const checkHome = checkPermission('home');

  const logo =
    themeMode === 'light'
      ? settings?.ui?.theming?.logo?.light
      : settings?.ui?.theming?.logo?.dark;

  const classes = cn(className, 'object-contain');

  return (
    <>
    {checkHome && (
    <Link to={PATHS.HOME}>
      <img src={logo} className={classes} />
    </Link>
    )}
    </>
  );
};
